import { render, staticRenderFns } from "./navbarItem.vue?vue&type=template&id=5814d74f&"
import script from "./navbarItem.js?vue&type=script&lang=js&"
export * from "./navbarItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports